// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DownloadAgent{align-items:center;cursor:pointer;display:flex;height:100px;justify-content:center;padding:10px}.DownloadAgent .icon{width:40px}.DownloadAgent .icon img{opacity:.7;width:100%}.DownloadAgent span{color:#616161;display:block;margin-left:10px;text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
